import type { TextProps } from '@/components/control/components/text/text.types';
import { useBoolean, useToggle } from 'usehooks-ts';
import clsx from 'clsx';
import Control from '@/components/control';
import '@/components/control/components/text/text.css';

export default function Text(props: TextProps) {
  const { value: isIdle, setTrue: makeIdle, setFalse: makeActive } = useBoolean(true);
  const [focused, toggleFocused] = useToggle();

  const onAutofill = () => {
    makeActive();
  };

  const onAutofillCancel = () => {
    if (props.value) return;
    makeIdle();
  };

  const onFocus = (id: string) => {
    if (!props.value) makeActive();
    toggleFocused();
    props.onFocus?.call(null, id);
  };

  const onBlur = (id: string) => {
    if (!props.value) makeIdle();
    toggleFocused();
    props.onBlur?.call(null, id);
  };

  return (
    <Control.Box state={props.state} focused={focused}>
      <label htmlFor={props.id} className='control-text'>
        <div
          className={clsx(
            'control-text__label',
            !isIdle || props.value ? 'control-text__label--active' : 'control-text__label--idle',
          )}
        >
          <Control.Label postion={isIdle ? 'idle' : 'active'} state={isIdle ? 'idle' : props.state}>
            {props.label}
          </Control.Label>
        </div>
        <Control.Input
          disabled={props.disabled}
          type={props.type}
          filter={props.filter}
          id={props.id}
          value={props.value}
          onChange={props.onChange}
          onAutofill={onAutofill}
          onAutofillCancel={onAutofillCancel}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </label>
    </Control.Box>
  );
}
